<template>
  <v-navigation-drawer clipped dark app width="350" v-model="showNavbarFlag" v-if="isActivated" ref="myNavDrawer"
    disable-resize-watcher @input="changeState">
    <v-list nav dense>
      <v-list-item to="/home" :input-value="to === $route.path ? 'abc' : ''">
        <v-list-item-icon>
          <v-icon v-text="home.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="home.name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group no-action prepend-icon="description" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>About Us</v-list-item-title>
        </template>
        <v-list-item to="/about/work" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-content>
            <v-list-item-title v-text="'The Work of RTL'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/about/logo" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-content>
            <v-list-item-title v-text="'RTL Logo'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/about/terms" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-content>
            <v-list-item-title v-text="'Terms and Conditions'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/about/contact" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-content>
            <v-list-item-title v-text="'Contact Us'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-subheader v-if="isMember">SERMON ARCHIVE</v-subheader>

      <v-list-group prepend-icon="audiotrack" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Audio Sermons</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2006</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/1" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'8AM'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/2" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'11AM'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/3" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Combined'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/4" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Evening Service'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2007</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/5" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'8AM'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/6" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'11AM'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/7" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Combined'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/8" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Evening Service'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2008</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/9" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'8AM'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/10" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'11AM'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/11" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Combined'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/12" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Evening Service'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group no-action prepend-icon="ondemand_video" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Video Sermons</v-list-item-title>
        </template>
        <v-list-item to="/authorvideolist/2" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="'Rev Charles Seet'"></v-list-item-title>
        </v-list-item>
        <v-list-item to="/authorvideolist/11" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="'Rev Calvin Loh'"></v-list-item-title>
        </v-list-item>
        <v-list-item to="/authorvideolist/14" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="'Rev Philip Heng'"></v-list-item-title>
        </v-list-item>
        <v-list-item to="/authorvideolist/24" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="'Rev Daniel Khoo'"></v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-subheader v-if="isMember || isADSS">SUNDAY SCHOOL</v-subheader>

      <v-list-group no-action prepend-icon="book" :value="false" v-if="isMember || isADSS">
        <template v-slot:activator>
          <v-list-item-title>Adult Sunday School</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2005</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/19" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Exodus by Eld Sherman Ong'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2006</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/20" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Joshua by Eld Ng Beng Kiong'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2007</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/21" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Luke by Eld Sherman Ong'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/80" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Acts by Eld Sherman Ong'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2008</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/81" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Acts by Eld Sherman Ong'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/82" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Nehemiah by Eld Ng Beng Kiong'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2009</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/83" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Esther by Eld Ng Beng Kiong'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2021</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/92" :input-value="to === $route.path ? 'abc' : ''" v-if="isMember">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Luke by Eld Ng Beng Kiong'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/104" :input-value="to === $route.path ? 'abc' : ''" v-if="isMember">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Walk Through the New Testament'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember || isADSS">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2022</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/106/latest" :input-value="to === $route.path ? 'abc' : ''"
            v-if="isMember">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Spiritual Lessons From the Lives of Abraham, Isaac & Jacob'">
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/115/latest" :input-value="to === $route.path ? 'abc' : ''"
            v-if="isMember || isADSS">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Spiritual Lessons From the Life of David'">
            </v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember || isADSS">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2024</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/164/latest" :input-value="to === $route.path ? 'abc' : ''"
            v-if="isMember">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Spiritual Lessons From the Life of Moses'">
            </v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/173" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Hebrews by Bro Mok Chee Cheong'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/175" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Paul\'s Authorship of Hebrews'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember || isADSS">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2025</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/176" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ "Paul's Epistle to the Galatians" }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group no-action prepend-icon="groups" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Senior Department</v-list-item-title>
        </template>
        <v-list-item to="/category/messagelist/84" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="'2020'"></v-list-item-title>
        </v-list-item>
        <v-list-item to="/category/messagelist/90" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="'2021'"></v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group no-action prepend-icon="unfold_more" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Others</v-list-item-title>
        </template>
        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2022
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/107/latest" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'YASS Apologetics'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group no-action prepend-icon="emoji_people" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Open Sunday</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2017</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/85" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'All'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2022</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/116" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/117" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2023</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/144" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/145" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2024</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/194" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/195" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group no-action prepend-icon="menu_book" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Reformation Sunday</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2023</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/158" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Returning to the Old Paths'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2024</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/196" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/197" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-subheader v-if="isMember">LECTURES</v-subheader>

      <v-list-group no-action prepend-icon="school" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Lectures</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2004</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/86" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Night Lectures by Dr David Allen'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2019</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/87" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'The Gospel According To Job by Ps TanSY'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-subheader v-if="isMember || isCampOnly">CAMPS</v-subheader>

      <v-list-group prepend-icon="terrain" :value="false" v-if="isMember || isCampOnly">
        <template v-slot:activator>
          <v-list-item-title>Church Camps</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2002</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/22" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/23" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/24" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Q & A'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/25" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Testimonies'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2003</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/26" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/27" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Morning Devotions'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/28" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/29" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Q & A'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/30" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2004</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/31" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/32" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/33" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Workshops'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/34" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Testimonies'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/35" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2005</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/40" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/41" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Morning Devotions'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/42" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/43" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Missionary Reports'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/44" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Workshops'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/45" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Testimonies'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/46" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2006</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/47" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/48" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Morning Devotions'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/49" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/50" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Missionary Reports'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/51" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Workshops'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/52" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Testimonies'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/53" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2007</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/58" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/59" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Morning Devotions'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/60" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/61" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Missionary Reports'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/62" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Song Items'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/63" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Testimonies'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/64" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2008</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/65" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/66" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Welcome & Opening'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/67" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Morning Devotions'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/68" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/69" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Missionary Reports'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/70" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Workshops'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/71" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Song Items'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/72" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Testimonies'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/73" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2019</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/13" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/14" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/15" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Q & A'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/16" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Tabletalk'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/17" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Testimonies'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/18" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2023</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/140" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/141" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/142" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Q & A'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/143" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/eventphotolist/149" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'photo_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Photos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember || isCampOnly">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>2024</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/165" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/166" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Morning Devotions'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/167" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/168" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Q & A'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/169" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-subheader v-if="isMember || isSeminarOnly">SEMINARS & CONFERENCES</v-subheader>

      <v-list-group prepend-icon="church" :value="false" v-if="isMember || isSeminarOnly">
        <template v-slot:activator>
          <v-list-item-title>Church Seminars</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Bible Seminar 2020</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/74" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/75" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/76" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Family Seminar 2021</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/96" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/97" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/98" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember || isSeminarOnly">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>CMI Seminar 2021</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/99" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/100" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'info'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Information'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/101" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Bible Geography 2022
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/113" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/114" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>MM/LF Combined Seminar 2022
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/120" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/121" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Reformation Seminar 2022</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/127" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/128" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Mental Health Seminar 2023</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/138" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/139" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>A Marriage Enrichment Seminar 2023</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/159" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/160" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group prepend-icon="directions_walk" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Missions Seminars<v-badge inline content="NEW"></v-badge></v-list-item-title>
        </template>

       <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Missions Seminar 2021</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/108" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/109" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'info'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Information'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/110" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        
       <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Missions Seminar 2024<v-badge inline content="NEW"></v-badge></v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/177" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/178" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/179" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Q & A'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group prepend-icon="diversity_2" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Young Lifers Ministry Seminars<v-badge inline content="NEW"></v-badge></v-list-item-title>
        </template>

       <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>YLM Seminar 2022</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/125" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/126" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

      <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>YLM Social Media Seminar 2023</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/154" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/155" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        
       <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>YLM Seminar 2024<v-badge inline content="NEW"></v-badge></v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/180" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/181" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/182" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Q & A'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false" v-if="isMember">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>The Multigenerational Church 2024<v-badge inline content="NEW"></v-badge></v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/183" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/184" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>
        
      <v-list-group prepend-icon="medical_services" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>GAF Medical Seminars</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Orthopaedics (2020)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/78" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/79" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Cancers (2021)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/93" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/94" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'playlist_play'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Messages'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/95" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Diabetes (2021)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/102" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/103" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>UTI & Prostate Cancer (2021)
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/111" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/112" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Gastrointestinal Symptoms (2022)
              </v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/118" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/119" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Men's Sexual Health & BPH (2022)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/123" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/124" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Dental Health (2023)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/136" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/137" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group prepend-icon="diversity_1" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Senior Fellowship Seminars<v-badge inline content="NEW"></v-badge></v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Dementia (2024)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/170" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/171" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

       <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Refire Not Retire! (2024)<v-badge inline content="NEW"></v-badge></v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/192" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/193" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group prepend-icon="fort" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>The Presbytery Seminars<v-badge inline content="NEW"></v-badge></v-list-item-title>
        </template>

      <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>fAIth in AI? (2023)<v-badge inline content="NEW"></v-badge></v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/185" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/186" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

       <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>The Presbytery Get-Together (2024)<v-badge inline content="NEW"></v-badge></v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/187" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/188" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/189" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'audio_file'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Audio'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        
       <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>The Presbytery Seminar 2024<v-badge inline content="NEW"></v-badge></v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/190" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/191" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-subheader v-if="isMember">FELLOWSHIP GROUPS</v-subheader>

      <v-list-group no-action prepend-icon="groups_3" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Men's Ministry</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>6th Anniversary (2022)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/148" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/122" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>7th Anniversary (2023)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/146" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/147" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Thanksgiving Fellowship (2023)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/161" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/162" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>


      <v-list-group no-action prepend-icon="diversity_3" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Ladies' Fellowship</v-list-item-title>
        </template>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>44th Anniversary (2022)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/150" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/151" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>45th Anniversary (2023)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/152" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/153" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group no-action prepend-icon="diversity_1" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Golden Age Fellowship</v-list-item-title>
        </template>
        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>CNY Lunch Meeting (2023)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/133" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>23rd Anniversary (2023)</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/134" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/135" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Videos'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-subheader v-if="isMember">SPECIAL EVENTS</v-subheader>

      <v-list-group prepend-icon="music_note" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Musical Events</v-list-item-title>
        </template>
        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>Combined B-P Musical 2022</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/130" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/131" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'auto_stories'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Musical E-Booklet'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/132" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group no-action sub-group :value="false">
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>An Evening of Praise 2023</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/category/messagelist/156" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'house'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Home'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="/category/messagelist/157" :input-value="to === $route.path ? 'abc' : ''">
            <v-list-item-icon>
              <v-icon v-text="'video_library'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Video'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>

      <v-list-group no-action prepend-icon="local_activity" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Church Anniversary</v-list-item-title>
        </template>
        <v-list-item to="/category/messagelist/88" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="'2010'"></v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-subheader v-if="isMember">CURRENT WORSHIP SERVICES</v-subheader>

      <v-list-item v-if="isMember" to="/category/messagelist/77" :input-value="to === $route.path ? 'abc' : ''">
        <v-list-item-icon>
          <v-icon v-text="'music_video'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="'Worship Service Hymns'"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group no-action prepend-icon="live_tv" :value="false" v-if="isMember">
        <template v-slot:activator>
          <v-list-item-title>Worship Service Recordings</v-list-item-title>
        </template>
        <v-list-item to="/category/messagelist/55/latest" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'2020'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/category/messagelist/91/latest" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'2021'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/category/messagelist/105/latest" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'2022'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/category/messagelist/129/latest" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'2023'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/category/messagelist/163/latest" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'2024'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/category/messagelist/174/latest" :input-value="to === $route.path ? 'abc' : ''">
          <v-list-item-icon>
            <v-icon v-text="'video_library'"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'2025'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item v-if="isMember" to="/livestream" :input-value="to === $route.path ? 'abc' : ''">
        <v-list-item-icon>
          <v-icon v-text="'videocam'"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="'Worship Service Streaming'"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn block @click="$vuetify.goTo(1000, { container: navDrawerContent, duration: 700 })">
          Scroll To Bottom <v-icon v-text="'vertical_align_bottom'"></v-icon>
        </v-btn>
      </div>
    </template>

  </v-navigation-drawer>
</template>

<script>
export default {
  watch: {
    $route(to, from) {
      this.showNavbarFlag = false || this.$vuetify.breakpoint.lgAndUp;
    },
  },
  computed: {
    isActivated: function () {
      return this.$store.getters.isActivated;
    },
    isMember: function () {
      return this.$store.getters.isMember;
    },
    isSeminarOnly: function () {
      return this.$store.getters.isSeminarOnly;
    },
    isCampOnly: function () {
      return this.$store.getters.isCampOnly;
    },
    isADSS: function () {
      return this.$store.getters.isADSS;
    },
  },
  data: () => ({
    showNavbarFlag: null,
    home: {
      name: "Home",
      route: "/home",
      icon: "home",
    },
    pending: {
      name: "Pending",
      route: "/pending",
      icon: "hourglass_full",
    },
    navDrawerContent: null,
  }),
  mounted() {
    this.navDrawerContent = this.$refs["myNavDrawer"].$el.querySelector(
      "div.v-navigation-drawer__content"
    );
  },
  created() {
    this.showNavbarFlag = this.$vuetify.breakpoint.lgAndUp;
    this.$bus.$on("navClick", (data) => {
      this.showNavbarFlag = !this.showNavbarFlag;
    });
  },
  methods: {
    changeState(state) {
      this.showNavbarFlag = state;
    },
  },
};
</script>
